"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = exports.BREAKPOINTS = void 0;

var _styledComponents = require("styled-components");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BREAKPOINTS = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px'
};
exports.BREAKPOINTS = BREAKPOINTS;
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html {\n    --color-text-blue: #176DB6;\n    --color-rm-secondary-blue: #115288;\n    --color-hover-blue: #1D89FF;\n    --color-text-black: #202020;\n    --color-text-gray: #626262;\n    --color-text-white: #FFF;\n    --color-red: #B1392A;\n    --color-background-gray: #F2F2F2;\n    --color-error: #EE0000;\n    \n    --font-serif: mrs-eaves-xl-serif-narrow, serif;\n    --font-sans: Gotham SSm A, Gotham SSm B, sans-serif;\n    --font-size-sm: 12px;\n    --letter-height-sm: 14px;\n\n    --min-tap-target-height: 50px;\n  }\n"])));
exports.GlobalStyle = GlobalStyle;